import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import HtmlComponent from '../HtmlComponent';
import { getVisibleCustomTeacherTabs } from '../../services/CustomTeacherTabService';

const CustomTeacherTabPanel = observer(({ lessonElementId, tabId }) => {
  const {
    lessonManager
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const tab = getVisibleCustomTeacherTabs(model).find((customTab) => customTab.id === tabId);

  if (!tab) {
    return null;
  }

  return (
    <div className='teacher-notes-panel flyout-panel custom-teacher-tab-panel'>
      <h2 className='panel-header' title={tab.fullTabName || tab.displayName}>{tab.fullTabName || tab.displayName}</h2>
      <div className='teacher-notes-wrapper'>
        <div className='teacher-notes-container'>
          <div className='teacher-notes-textbox-wrapper'>
            <HtmlComponent htmlStr={tab.content} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default CustomTeacherTabPanel;
